export const PasswordErrorMappings: any = {
  minCharacters: 'errors.password.minCharacters',
  hasLowercase: 'errors.password.hasLowerCase',
  hasUppercase: 'errors.password.hasUpperCase',
  hasNumber: 'errors.password.hasNumber',
  hasSpecialCharacter: 'errors.password.hasSpecialCharacter',
  isEmpty: '',
};
